module.exports = __webpack_public_path__ + "img/logo1.33288b50.png";